<template>
  <div class="billreport">
    <div class="title">
      <h2>Smart Tracking Report</h2>
    </div>
    <div class="bgf0">
      <el-row type="flex">
        <el-col :span="24" style="padding:16px;">
          <el-card shadow="hover" class="pad30">
            <el-form :model="filterInfo" :inline="true">
              <el-row :gutter="24">
                <el-col :xs="24" :sm="2" :md="2" :lg="2" :xl="2">
                  <label class="labelName">Offer(s)</label>
                </el-col>
                <el-form-item label="OfferId(s)" label-width="1.8rem">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-input
                      v-model="filterInfo.offerIds"
                      placeholder="offerIds: eg. 2206264 or 2206264,1567396"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="OfferName" label-width="2rem">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-input
                      v-model="filterInfo.offerName"
                      placeholder="OfferName: eg. Mobile Strike"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                    <el-checkbox v-model="offerChecked"></el-checkbox>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row :gutter="24">
                <el-col :xs="24" :sm="2" :md="2" :lg="2" :xl="2">
                  <label class="labelName">Affiliate(s)</label>
                </el-col>
                <el-form-item label="AffiliateId(s)" label-width="2.08rem">
                  <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">
                    <group-select
                      v-model="filterInfo.affIds"
                      :data-source="affiliatesGroupList"
                      multiple
                      :loading="affiliateLoading"
                      clearable
                      filterable
                      reserve-keyword
                      placeholder="请选择"
                      style="width:10.14rem;"
                    />
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                    <el-checkbox v-model="affiliateChecked"></el-checkbox>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row :gutter="24">
                <el-col :xs="24" :sm="2" :md="2" :lg="2" :xl="2">
                  <label class="labelName">Source(s)</label>
                </el-col>
                <el-form-item label="Source(s)" label-width="1.8rem">
                  <el-col :xs="24" :sm="12" :md="12" :lg="10" :xl="12">
                    <group-select
                      v-model="filterInfo.sourceIds"
                      :data-source="sourcesList"
                      multiple
                      :loading="sourceLoading"
                      clearable
                      reserve-keyword
                      filterable
                      placeholder="请选择"
                      style="width:3.95rem;"
                    />
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                    <el-checkbox v-model="sourceChecked"></el-checkbox>
                  </el-col>
                </el-form-item>
                <el-form-item label="SourceOfferId" label-width="2rem">
                  <el-col :xs="22" :sm="12" :md="12" :lg="6" :xl="12">
                    <el-input
                      v-model="filterInfo.sourceOfferIds"
                      placeholder="source offer id here"
                      style="width:2.82rem;"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                    <el-checkbox v-model="sourceOfferIdChecked"></el-checkbox>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row :gutter="24">
                <el-col :lg="2" :md="2" :xs="24" :sm="2" :xl="2">
                  <label class="labelName">Aff_sub(s)</label>
                </el-col>
                <el-form-item label="Aff_Sub" label-width="1.64rem">
                  <el-col :lg="20" :md="20" :xs="24" :sm="20" :xl="20">
                    <el-input
                      v-model="filterInfo.affSubs"
                      style="width:10.64rem;"
                      placeholder="eg. carry_i or carry_i,carry_j"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                    <el-checkbox v-model="affSubsChecked"></el-checkbox>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row>
                <label class="labelName" style="margin-right:20px;">TimeZone</label>
                <el-form-item>
                  <el-select v-model="filterInfo.timezone" style="width:420px;">
                    <el-option
                      v-for="item in timezoneOption"
                      :key="item.value"
                      :value="item.number"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :lg="3" :md="3" :xs="3" :sm="3" :xl="3">
                  <label class="labelName">Interval</label>
                </el-col>
                <el-col :lg="6" :md="6" :xs="6" :sm="6" :xl="6">
                  <el-form-item label="Month">
                    <el-checkbox v-model="monthChecked"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :lg="6" :md="6" :xs="6" :sm="6" :xl="6">
                  <el-form-item label="Date">
                    <el-checkbox v-model="dateChecked"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :lg="6" :md="6" :xs="6" :sm="6" :xl="6">
                  <el-form-item label="Hour">
                    <el-checkbox v-model="hourChecked"></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <label class="labelName" style="margin-right:60px;">Date</label>
                <el-form-item>
                  <el-date-picker
                    v-model="startToEndDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    style="width:260px;"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :lg="3" :md="3" :xs="3" :sm="3" :xl="3">
                  <label class="labelName" style="margin-right:40px;">Sort by</label>
                </el-col>
                <el-col :lg="20" :md="20">
                  <el-form-item>
                    <el-radio-group v-model="filterInfo.sortMark">
                      <el-radio
                        style="margin-right:140px;"
                        v-for="item in radioOptions"
                        :key="item"
                        :label="item"
                      >
                        {{ item }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :lg="8" :md="20" :offset="1">
                  <el-form-item>
                    <el-button type="primary" @click="searchListClick(1)">In Browser</el-button>
                  </el-form-item>
                  <el-form-item>
                    <!--                    <el-button type="primary" @click="exportExcelFileClick">-->
                    <!--                      Download Excel-->
                    <!--                    </el-button>-->
                    <!--                    <el-button type="primary" @click="exportDetailClick">Download Detail</el-button>-->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-card shadow="hover">
            <el-table
              v-loading="listLoading"
              ref="tableRef"
              style="width:100%;"
              height="70vmin"
              stripe
              border
              :data="reportDataList"
              highlight-current-row
            >
              <el-table-column
                label="Date"
                prop="date"
                fixed="left"
                align="center"
                width="170"
                key="date"
              ></el-table-column>
              <el-table-column
                label="Affiliate ID"
                :fixed="fullWidth <= 768 ? false : 'left'"
                min-width="100"
                align="center"
                v-if="affiliateChecked"
                key="affiliateId"
              >
                <template slot-scope="scope">
                  <span class="cor337ab7" @click="affiliatetailClick(scope.row)">{{
                    scope.row.affiliateId
                  }}</span>
                  <el-tag
                    v-if="scope.row.affiliateTrafficTag"
                    :color="scope.row.affColor"
                    style="color:white;height:24px;line-height:24px;"
                  >
                    {{ scope.row.affiliateTrafficTag }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="Affiliate Name"
                :fixed="fullWidth <= 768 ? false : 'left'"
                width="140"
                align="center"
                v-if="affiliateChecked"
                key="affiliateName"
              >
                <template slot-scope="scope">
                  <span class="cor337ab7" @click="affiliatetailClick(scope.row)">{{
                    scope.row.affiliateName
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Source ID"
                v-if="sourceChecked"
                width="100"
                align="center"
                key="sourceId"
              >
                <template slot-scope="scope">
                  <span class="cor337ab7" @click="sourcedetailClick(scope.row)">{{
                    scope.row.sourceId
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Source Name"
                width="140"
                align="center"
                v-if="sourceChecked"
                key="sourceName"
              >
                <template slot-scope="scope">
                  <span class="cor337ab7" @click="sourcedetailClick(scope.row)">{{
                    scope.row.sourceName
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Aff Sub"
                prop="affSub"
                width="150"
                align="center"
                v-if="affSubsChecked"
                key="affSub"
              >
              </el-table-column>
              <el-table-column
                label="Offer ID"
                align="center"
                v-if="offerChecked"
                width="110"
                key="offerId"
              >
                <template slot-scope="scope">
                  <span class="cor337ab7" @click="offerdetailClick(scope.row)">{{
                    scope.row.offerId
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Offer Name"
                v-if="offerChecked"
                width="140"
                align="center"
                show-overflow-tooltip
                key="offerName"
              >
                <template slot-scope="scope">
                  <span class="cor337ab7" @click="offerdetailClick(scope.row)">{{
                    scope.row.offerName
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Sub Source ID"
                prop="subSourceId"
                width="130"
                align="center"
                key="subSourceId"
              ></el-table-column>
              <el-table-column
                label="Sub Offer ID"
                prop="subOfferId"
                width="130"
                align="center"
                key="subOfferId"
              ></el-table-column>
              <el-table-column
                label="Payout"
                prop="payout"
                width="130"
                align="center"
                key="payout"
              ></el-table-column>
              <el-table-column
                label="Revenue"
                prop="revenue"
                width="130"
                align="center"
                key="revenue"
              ></el-table-column>
            </el-table>
            <pagination
              class="block pagePanel"
              :pageTotal="total"
              @handleSizeChange="handleSizeChange"
              @handleCurrentChange="handleCurrentChange"
              :pageSize="pageParam.pageSize"
              :currentPage="pageParam.page"
            ></pagination>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import { api, getSmartTrackingReport } from 'api/report';

  import Pagination from '@/components/pagination';
  import GroupSelect from '@/components/GroupSelect';
  import { cloneDeep } from 'lodash-es';
  import dateUtils from '@/utils/dateutils.js';
  import { myMixin } from '@/mixins/mixins.js';
  import optionData from '@/assets/js/optionData';
  import { filterObject } from 'utils/utils';
  import { mapActions, mapState } from 'vuex';
  import qs from 'querystring';

  export default {
    mixins: [myMixin],
    components: {
      Pagination,
      GroupSelect,
    },
    data() {
      return {
        pageParam: {
          page: 1,
          pageSize: 20,
        },
        reportDataList: [],
        dataParam: null,
        affiliateChecked: true,
        offerChecked: false,
        sourceChecked: false,
        sourceOfferIdChecked: false,
        fullWidth: document.documentElement.clientWidth,
        affSubsChecked: false,
        monthChecked: false,
        dateChecked: true,
        hourChecked: true,
        total: 0,
        listLoading: false,
        summariesMap: {},
        startToEndDate: '',
        timezoneOption: optionData.timezoneOption,
        affiliateIdArray: [],
        radioOptions: ['payout', 'revenue'],
        filterInfo: {
          affIds: null,
          affSubs: null,
          sourceIds: null,
          offerIds: null,
          offerName: null,
          fromDate: null,
          endDate: null,
          timezone: 0,
          groupMarks: [],
          timeMarks: [],
          sortMark: 'payout',
          sourceOfferId: '',
        },
      };
    },
    computed: {
      ...mapState('affiliate', {
        affiliatesGroupList: (state) => state.affiliatesGroupList,
        affiliateLoading: (state) => state.affiliateLoading,
      }),
      ...mapState('source', {
        sourcesList: (state) => state.sourcesList,
        sourceLoading: (state) => state.sourceLoading,
      }),
      listenChange() {
        const {
          affiliateChecked,
          sourceChecked,
          offerChecked,
          affSubsChecked,
          sourceOfferIdChecked,
        } = this;
        return {
          affiliateChecked,
          sourceChecked,
          offerChecked,
          affSubsChecked,
          sourceOfferIdChecked,
        };
      },
    },
    mounted() {
      //默认选择
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() + 3600 * 1000 * 24);
      this.startToEndDate = [];
      this.startToEndDate[0] = dateUtils.date2StrYMD(end);
      this.startToEndDate[1] = dateUtils.date2StrYMD(start);

      this.getAffiliateList();
      this.getSourceIdsList();
    },
    watch: {
      listenChange: function() {
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout();
        });
      },
    },
    methods: {
      ...mapActions('affiliate', ['getAffiliateList']),
      ...mapActions('source', ['getSourceIdsList']),
      searchListClick(curPage) {
        if (curPage) {
          this.pageParam.page = curPage;
        }
        let param = {
          ...this.filterInfo,
          ...this.pageParam,
        };

        if (Array.isArray(param.sourceIds) && param.sourceIds.length > 0) {
          param.sourceIds = param.sourceIds.join(',');
        } else {
          delete param.sourceIds;
        }
        if (Array.isArray(param.affIds) && param.affIds.length > 0) {
          param.affIds = param.affIds.join(',');
        } else {
          delete param.affIds;
        }
        if (this.offerChecked == true && param.groupMarks.indexOf('offerId') == -1) {
          param.groupMarks.push('offerId');
        } else if (this.offerChecked == false && param.groupMarks.indexOf('offerId') !== -1) {
          const offerIdIndex = param.groupMarks.findIndex((item) => {
            if (item == 'offerId') {
              return true;
            }
          });
          param.groupMarks.splice(offerIdIndex, 1);
        }

        if (this.affiliateChecked == true && param.groupMarks.indexOf('affiliateId') == -1) {
          param.groupMarks.push('affiliateId');
        } else if (
          this.affiliateChecked == false &&
          param.groupMarks.indexOf('affiliateId') !== -1
        ) {
          const affiliateIndex = param.groupMarks.findIndex((item) => {
            if (item == 'affiliateId') {
              return true;
            }
          });
          param.groupMarks.splice(affiliateIndex, 1);
        }

        if (this.sourceChecked == true && param.groupMarks.indexOf('sourceId') == -1) {
          param.groupMarks.push('sourceId');
        } else if (this.sourceChecked == false && param.groupMarks.indexOf('sourceId') !== -1) {
          const sourceIdIndex = param.groupMarks.findIndex((item) => {
            if (item == 'sourceId') {
              return true;
            }
          });
          param.groupMarks.splice(sourceIdIndex, 1);
        }
        if (this.sourceOfferIdChecked == true && param.groupMarks.indexOf('sourceOfferId') == -1) {
          param.groupMarks.push('sourceOfferId');
        } else if (
          this.sourceOfferIdChecked == false &&
          param.groupMarks.indexOf('sourceOfferId') !== -1
        ) {
          const sourceOfferIdIndex = param.groupMarks.findIndex((item) => {
            if (item == 'sourceOfferId') {
              return true;
            }
          });
          param.groupMarks.splice(sourceOfferIdIndex, 1);
        }

        if (this.affSubsChecked == true && param.groupMarks.indexOf('affSub') == -1) {
          param.groupMarks.push('affSub');
        } else if (this.affSubsChecked == false && param.groupMarks.indexOf('affSub') !== -1) {
          const affSubIndex = param.groupMarks.findIndex((item) => {
            if (item == 'affSub') {
              return true;
            }
          });
          param.groupMarks.splice(affSubIndex, 1);
        }

        if (this.monthChecked == true && param.timeMarks.indexOf('month') == -1) {
          param.timeMarks.push('month');
        } else if (this.monthChecked == false && param.timeMarks.indexOf('month') !== -1) {
          const monthIndex = param.timeMarks.findIndex((item) => {
            if (item == 'month') {
              return true;
            }
          });
          param.timeMarks.splice(monthIndex, 1);
        }

        if (this.dateChecked == true && param.timeMarks.indexOf('date') == -1) {
          param.timeMarks.push('date');
        } else if (this.dateChecked == false && param.timeMarks.indexOf('date') !== -1) {
          const dateIndex = param.timeMarks.findIndex((item) => {
            if (item == 'date') {
              return true;
            }
          });
          param.timeMarks.splice(dateIndex, 1);
        }

        if (this.hourChecked == true && param.timeMarks.indexOf('hour') == -1) {
          param.timeMarks.push('hour');
        } else if (this.hourChecked == false && param.timeMarks.indexOf('hour') !== -1) {
          const hourIndex = param.timeMarks.findIndex((item) => {
            if (item == 'hour') {
              return true;
            }
          });
          param.timeMarks.splice(hourIndex, 1);
        }

        if (this.startToEndDate.length === 2) {
          let startDate = this.startToEndDate[0];
          let endDate = this.startToEndDate[1];
          param.fromDate = startDate;
          param.endDate = endDate;
        }

        this.pageParam.page = 1;

        const dataParam = cloneDeep(param);
        if (Array.isArray(dataParam.groupMarks)) {
          dataParam.groupMarks = dataParam.groupMarks.join(',');
        }
        if (Array.isArray(dataParam.timeMarks)) {
          dataParam.timeMarks = dataParam.timeMarks.join(',');
        }
        this.dataParam = dataParam;
        this.getSmartTrackingReport();
      },
      getSmartTrackingReport() {
        this.listLoading = true;
        let param = {
          ...this.dataParam,
          ...this.pageParam,
        };
        param = filterObject(param);
        getSmartTrackingReport(param).then((response) => {
          this.listLoading = false;
          if (response.code === 200) {
            const result = response.result ?? {};
            const summariesMap = result.totalLine ?? {};
            const reportDataList = result.data || [];
            this.summariesMap = summariesMap;
            this.reportDataList = reportDataList;
            if (this.reportDataList.length > 0) {
              this.total = result.total;
              let totalObject = new Object();
              totalObject.date = 'Total';
              totalObject.payout = this.summariesMap.payout;
              totalObject.revenue = this.summariesMap.revenue;
              this.reportDataList.push(totalObject);
            }
          } else {
            this.reportDataList = [];
            this.$message.error('Error: ' + response.message);
          }
        });
      },
      exportExcelFileClick() {
        let param = {};
        let groupMarks = new Array();
        let timeMarks = new Array();
        if (this.affiliateChecked == true && groupMarks.indexOf('affiliateId') == -1) {
          groupMarks.push('affiliateId');
        } else if (this.affiliateChecked == false && groupMarks.indexOf('affiliateId') !== -1) {
          const affiliateIdIndex = groupMarks.findIndex((item) => {
            if (item == 'affiliateId') {
              return true;
            }
          });
          groupMarks.splice(affiliateIdIndex, 1);
        }

        if (this.sourceChecked == true && groupMarks.indexOf('sourceId') == -1) {
          groupMarks.push('sourceId');
        } else if (this.sourceChecked == false && groupMarks.indexOf('sourceId') !== -1) {
          const sourceIdIndex = groupMarks.findIndex((item) => {
            if (item == 'sourceId') {
              return true;
            }
          });
          groupMarks.splice(sourceIdIndex, 1);
        }
        if (this.sourceOfferIdChecked == true && groupMarks.indexOf('sourceOfferId') == -1) {
          groupMarks.push('sourceOfferId');
        } else if (
          this.sourceOfferIdChecked == false &&
          groupMarks.indexOf('sourceOfferId') !== -1
        ) {
          const sourceOfferIdIndex = groupMarks.findIndex((item) => {
            if (item == 'sourceOfferId') {
              return true;
            }
          });
          groupMarks.splice(sourceOfferIdIndex, 1);
        }

        if (this.offerChecked == true && groupMarks.indexOf('offerId') == -1) {
          groupMarks.push('offerId');
        } else if (this.offerChecked == false && groupMarks.indexOf('offerId') !== -1) {
          const offerIdIndex = groupMarks.findIndex((item) => {
            if (item == 'offerId') {
              return true;
            }
          });
          groupMarks.splice(offerIdIndex, 1);
        }

        if (this.affSubsChecked == true && groupMarks.indexOf('affSub') == -1) {
          groupMarks.push('affSub');
        } else if (this.affSubsChecked == false && groupMarks.indexOf('affSub') !== -1) {
          const affSubIndex = groupMarks.findIndex((item) => {
            if (item == 'affSub') {
              return true;
            }
          });
          groupMarks.splice(affSubIndex, 1);
        }

        if (this.monthChecked == true && timeMarks.indexOf('month') == -1) {
          timeMarks.push('month');
        } else if (this.monthChecked == false && timeMarks.indexOf('month') !== -1) {
          const monthIndex = timeMarks.findIndex((item) => {
            if (item == 'month') {
              return true;
            }
          });
          timeMarks.splice(monthIndex, 1);
        }

        if (this.dateChecked == true && timeMarks.indexOf('date') == -1) {
          timeMarks.push('date');
        } else if (this.dateChecked == false && timeMarks.indexOf('date') !== -1) {
          const dateIndex = timeMarks.findIndex((item) => {
            if (item == 'date') {
              return true;
            }
          });
          timeMarks.splice(dateIndex, 1);
        }

        if (this.hourChecked == true && timeMarks.indexOf('hour') == -1) {
          timeMarks.push('hour');
        } else if (this.hourChecked == false && timeMarks.indexOf('hour') !== -1) {
          const hourIndex = timeMarks.findIndex((item) => {
            if (item == 'hour') {
              return true;
            }
          });
          timeMarks.splice(hourIndex, 1);
        }

        param['fromDate'] = this.startToEndDate[0];
        param['endDate'] = this.startToEndDate[1];
        if (this.filterInfo.timezone != null) {
          param['timezone'] = this.filterInfo.timezone;
        }

        if (this.filterInfo.sourceIds != null && this.filterInfo.sourceIds.length > 0) {
          param['sourceIds'] = this.filterInfo.sourceIds + '';
        }

        if (this.filterInfo.affIds !== null && this.filterInfo.affIds.length !== 0) {
          param['affIds'] = this.filterInfo.affIds + '';
        }
        if (this.filterInfo.affSubs != null) {
          param['affSubs'] = this.filterInfo.affSubs + '';
        }

        if (this.filterInfo.offerIds != null) {
          param['offerIds'] = this.filterInfo.offerIds;
        }

        if (groupMarks != null) {
          param['groupMarks'] = groupMarks.join(',');
        }
        if (timeMarks != null) {
          param['timeMarks'] = timeMarks.join(',');
        }
        if (this.filterInfo.offerName != null) {
          param['offerName'] = encodeURI(this.filterInfo.offerName);
        }
        param = filterObject(param);
        let strParam = qs.stringify(param);
        window.open(`${api.DOWNLOAD_BILL_REPORT}?${strParam}`, '_blank');
      },
      exportDetailClick() {
        let param = {};
        let groupMarks = new Array();
        let timeMarks = new Array();
        if (this.affiliateChecked == true && groupMarks.indexOf('affiliateId') == -1) {
          groupMarks.push('affiliateId');
        } else if (this.affiliateChecked == false && groupMarks.indexOf('affiliateId') !== -1) {
          const affiliateIdIndex = groupMarks.findIndex((item) => {
            if (item == 'affiliateId') {
              return true;
            }
          });
          groupMarks.splice(affiliateIdIndex, 1);
        }

        if (this.sourceChecked == true && groupMarks.indexOf('sourceId') == -1) {
          groupMarks.push('sourceId');
        } else if (this.sourceChecked == false && groupMarks.indexOf('sourceId') !== -1) {
          const sourceIdIndex = groupMarks.findIndex((item) => {
            if (item == 'sourceId') {
              return true;
            }
          });
          groupMarks.splice(sourceIdIndex, 1);
        }
        if (this.sourceOfferIdChecked == true && groupMarks.indexOf('sourceOfferId') == -1) {
          groupMarks.push('sourceOfferId');
        } else if (
          this.sourceOfferIdChecked == false &&
          groupMarks.indexOf('sourceOfferId') !== -1
        ) {
          const sourceOfferIdIndex = groupMarks.findIndex((item) => {
            if (item == 'sourceOfferId') {
              return true;
            }
          });
          groupMarks.splice(sourceOfferIdIndex, 1);
        }

        if (this.offerChecked == true && groupMarks.indexOf('offerId') == -1) {
          groupMarks.push('offerId');
        } else if (this.offerChecked == false && groupMarks.indexOf('offerId') !== -1) {
          const offerIdIndex = groupMarks.findIndex((item) => {
            if (item == 'offerId') {
              return true;
            }
          });
          groupMarks.splice(offerIdIndex, 1);
        }

        if (this.affSubsChecked == true && groupMarks.indexOf('affSub') == -1) {
          groupMarks.push('affSub');
        } else if (this.affSubsChecked == false && groupMarks.indexOf('affSub') !== -1) {
          const affSubIndex = groupMarks.findIndex((item) => {
            if (item == 'affSub') {
              return true;
            }
          });
          groupMarks.splice(affSubIndex, 1);
        }

        if (this.monthChecked == true && timeMarks.indexOf('month') == -1) {
          timeMarks.push('month');
        } else if (this.monthChecked == false && timeMarks.indexOf('month') !== -1) {
          const monthIndex = timeMarks.findIndex((item) => {
            if (item == 'month') {
              return true;
            }
          });
          timeMarks.splice(monthIndex, 1);
        }

        if (this.dateChecked == true && timeMarks.indexOf('date') == -1) {
          timeMarks.push('date');
        } else if (this.dateChecked == false && timeMarks.indexOf('date') !== -1) {
          const dateIndex = timeMarks.findIndex((item) => {
            if (item == 'date') {
              return true;
            }
          });
          timeMarks.splice(dateIndex, 1);
        }

        if (this.hourChecked == true && timeMarks.indexOf('hour') == -1) {
          timeMarks.push('hour');
        } else if (this.hourChecked == false && timeMarks.indexOf('hour') !== -1) {
          const hourIndex = timeMarks.findIndex((item) => {
            if (item == 'hour') {
              return true;
            }
          });
          timeMarks.splice(hourIndex, 1);
        }

        param['fromDate'] = this.startToEndDate[0];
        param['endDate'] = this.startToEndDate[1];
        if (this.filterInfo.timezone != null) {
          param['timezone'] = this.filterInfo.timezone;
        }

        if (this.filterInfo.sourceIds != null && this.filterInfo.sourceIds.length > 0) {
          param['sourceIds'] = this.filterInfo.sourceIds + '';
        }

        if (this.filterInfo.affIds !== null && this.filterInfo.affIds.length !== 0) {
          param['affIds'] = this.filterInfo.affIds + '';
        }
        if (this.filterInfo.affSubs != null) {
          param['affSubs'] = this.filterInfo.affSubs + '';
        }

        if (this.filterInfo.offerIds != null) {
          param['offerIds'] = this.filterInfo.offerIds;
        }

        if (groupMarks != null) {
          param['groupMarks'] = groupMarks.join(',');
        }
        if (timeMarks != null) {
          param['timeMarks'] = timeMarks.join(',');
        }
        if (this.filterInfo.offerName != null) {
          param['offerName'] = encodeURI(this.filterInfo.offerName);
        }

        param.detailDownLoadFlag = true;
        param = filterObject(param);
        let strParam = qs.stringify(param);
        window.open(`${api.DOWNLOAD_REJECT_REPORT_DETAIL}?${strParam}`, '_blank');
      },
      affiliatetailClick(row) {
        const { href } = this.$router.resolve({
          path: '/affiliate/detail',
          query: {
            affiliateId: row.affiliateId,
          },
        });
        window.open(href, '_blank');
      },
      filterNull(val) {
        return val == null ? 0 : val;
      },
      showReportComparingItem(cur, last) {
        const pecent =
          cur == last
            ? '--'
            : 0 == last
            ? '100%'
            : new Number(Math.round(((cur - last) / last) * 100)) + '%';
        const color = cur > last ? 'green' : cur == last ? 'silver' : 'red';
        let result = cur;
        if (last != 0) {
          result += '<span style="color:' + color + '">(' + pecent + ')</span>';
        }
        return result;
      },
      handleSizeChange(size) {
        this.pageParam.pageSize = size;
        this.handleCurrentChange(1);
      },
      handleCurrentChange(currentPage) {
        this.pageParam.page = currentPage;
        this.getRejectReport();
      },
      offerdetailClick(row) {
        const { href } = this.$router.resolve({
          path: '/offer/detail',
          query: {
            offerId: row.offerId,
          },
        });
        window.open(href, '_blank');
      },
      sourcedetailClick(row) {
        const { href } = this.$router.resolve({
          path: '/source/detail',
          query: {
            sourceId: row.sourceId,
          },
        });
        window.open(href, '_blank');
      },
    },
  };
</script>
<style lang="scss" scoped></style>
<style lang="scss"></style>
